import { render, staticRenderFns } from "./theInspectionRules.vue?vue&type=template&id=dbd0efb6&scoped=true&"
import script from "./theInspectionRules.vue?vue&type=script&lang=js&"
export * from "./theInspectionRules.vue?vue&type=script&lang=js&"
import style0 from "./theInspectionRules.vue?vue&type=style&index=0&id=dbd0efb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd0efb6",
  null
  
)

export default component.exports